export class InspectionComponent {
	constructor() {
		this.componentTypeId = null;
		this.modelNumber = null;
		this.serialNumber = null;
		this.assetNumber = null;
	}

	static hydrate(jsonData) {
        let ic = Object.assign(new InspectionComponent(), jsonData);
		return ic;
	}
}